import OtpLogin from "./OtpLogin";

export default OtpLogin;
